'use strict'
/**
 * @Description:  环境配置文件
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/28 上午9:44
 */

let baseURL = '',         // 接口地址
  smartPollution = '';  // 污染源监测

if (process.env.NODE_ENV == 'development') {       // 本地调试
  baseURL = "broadcast";
  // smartPollution = 'http://10.96.9.73:9991';
  smartPollution = 'http://localhost:9991';

} else if (process.env.NODE_ENV == 'production') {  // 生产环境
  baseURL = window.configStatic.baseURL;
  smartPollution = window.configStatic.smartPollution;

} else if (process.env.NODE_ENV == 'testing') {     // 测试环境 129 44 45
  baseURL = window.configStatic.baseURL;
  smartPollution = window.configStatic.smartPollution;

} else if (process.env.NODE_ENV == 'previous') {    // 预上线环境 218
  baseURL = window.configStatic.baseURL;
  smartPollution = window.configStatic.smartPollution;

}

module.exports = {
  baseURL,
  smartPollution
};



// WEBPACK FOOTER //
// ./src/config/config.js